import StaticStickitView from '../static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting the breed-selection
  // The view takes a Query as its model.
  initialize(options) {
    this.$input = this.$('.js-breed-selector');
    this.pets = options.pets;

    // Listen for changes in pets
    if (this.model.get('pet') != null) {
      this.updateBreedSelection();
    }
    this.listenTo(this.model, 'change:pet', this.updateBreedSelection.bind(this));

    // Initialize breed selection
    this.$input.chosen({
      width: '100%',
      placeholder_text_multiple: 'Breeds',
    });

    // Listen for changes to breed selection
    // this.listenTo(this.$input, 'change', this.onBreedSelection.bind(this))
    this.$input.on('change', this.onBreedSelection.bind(this));

    StaticStickitView.prototype.initialize.call(this, options);
  },

  updateBreedSelection() {
    const pets = this.model.get('pet');
    const breeds = pets.map(p => this.pets[p]);
    this.model.set('breeds', breeds.join());
  },

  onBreedSelection() {
    this.startNewSearch();
  },

  startNewSearch() {
    let breeds = this.$input.val();
    if (Array.isArray(breeds)) {
      breeds = breeds.join();
      this.trigger('queryUpdated');
    }
    this.model.set('breeds', breeds);
    this.trigger('queryUpdated');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/breed_selection_view.js